import { useSpotlightSearchFromUrl } from "@circle-react/components/search/SpotlightSearchV4/hooks/useSpotlightSearchFromUrl";

export const HeaderV4SideEffects = () => {
  useSpotlightSearchFromUrl();
  return null;
};
